import { styled } from '@uhg-abyss/web/tools/styled';

export const Styles = styled('div', {
  marginLeft: 'var(--abyss-space-md)',
  marginRight: 'var(--abyss-space-xs)',
});
